<ac-card>
  <ac-card-content>
    <div class="purchase-dialog">
      <app-purchase-dialog-header
        imageUrl="{{ 'cdnUrl' | env }}/images/ftb_gift_box.webp"
        [imageSize]="140"
        (back)="back.emit()"
        (close)="close.emit()"
      />

      <div class="ftb">
        <!-- Header -->
        <div class="ftb__header">
          <h2 class="ac-headline-sm ftb__title">First Time Boost</h2>
          <p class="ac-body-md ftb__subtitle">
            You have {{ tierRows().length }} ways to boost your first purchase.
          </p>
        </div>

        <!-- Tier Cards -->
        <div class="ftb__tiers">
          @for (tier of tierRows(); track tier.price) {
            <div class="ftb__tier-card">
              <!-- Badge -->
              <div
                class="ftb__tier-badge"
                [style.background]="tier.badgeBg"
                [style.border-color]="tier.badgeBorder">
                <span [style.color]="tier.color">{{ tier.label }}</span>
                <span class="ftb__tier-badge-sep"> &bull; </span>
                <span>{{ tier.bonusPercent }}% BONUS</span>
              </div>

              <!-- Row content -->
              <div class="ftb__tier-content">
                <ac-icon iconKey="hr:bolt" [size]="32" [style.color]="tier.color" />

                <div class="ftb__tier-text">
                  <span class="ac-title-md ftb__tier-boosted">
                    {{ tier.totalGCLabel }} + {{ tier.totalSCLabel }}
                  </span>
                  <span class="ac-body-sm ftb__tier-base">
                    {{ tier.baseGCLabel }} + {{ tier.baseSCLabel }}
                  </span>
                </div>

                <button
                  class="ftb__tier-price-btn"
                  type="button"
                  (click)="onTierClick(tier.price)">
                  {{ tier.price | currency : 'USD' : 'symbol' : '1.2-2' }}
                </button>
              </div>
            </div>
          }
        </div>

        <!-- Continue button -->
        <button class="ftb__continue-btn" type="button" (click)="back.emit()">
          Continue to Purchase
        </button>

        <!-- Footer -->
        <p class="ac-body-sm ftb__footer">
          Custom amounts are automatically matched to the nearest tier.
        </p>
      </div>
    </div>
  </ac-card-content>
</ac-card>
